module.exports = __webpack_public_path__ + "img/epure-layer.c40a1eb6.svg";